import { render } from "./PaymentSuccess.vue?vue&type=template&id=100849aa&scoped=true"
import script from "./PaymentSuccess.vue?vue&type=script&lang=js"
export * from "./PaymentSuccess.vue?vue&type=script&lang=js"

import "./PaymentSuccess.vue?vue&type=style&index=0&id=100849aa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-100849aa"

export default script